var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMydata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7202_104951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 73.6667V88.5472C63 89.9018 64.0982 91 65.4528 91H86.5472C87.9018 91 89 89.9018 89 88.5472V73.6667",
    stroke: "#FC596C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0039 65L76.0039 82.3333",
    stroke: "#FC596C",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6451 77.1333L76.0022 82.3333L71.3594 77.1333",
    stroke: "#FC596C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.708 80.5955L101.975 59.9389C101.975 59.9389 97.849 61.0693 96.6337 64.5732C94.9945 69.3206 96.775 72.0051 98.1033 76.0459C99.2338 79.5782 101.24 84.4103 102.54 87.4621V97.0981V116.229C102.54 122.106 97.7359 126.91 91.8574 126.91H61.1365C58.0277 126.91 55.2298 125.582 53.2797 123.463C52.5449 123.378 51.8383 123.208 51.1035 122.954C57.4625 134.568 69.5869 147.623 69.5869 147.623L71.537 160H115.004L114.721 147.623C114.721 147.623 114.1 132.025 118.819 110.634C120.43 103.371 110.708 80.6802 110.708 80.652V80.5955Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4538 73.1639V62.0585L48.6733 61.4369C47.882 61.1543 47.0906 61.0412 46.2993 61.0412C44.0949 61.0412 42.1165 62.0868 41.41 63.867C40.4491 66.2407 42.0317 69.2925 44.9427 70.6489L50.4538 73.1921V73.1639Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6612 117.614C51.1025 118.913 52.8265 119.592 54.3244 119.592C55.8223 119.592 56.1897 119.281 56.8115 118.687C58.3659 117.133 57.8854 113.912 55.7375 111.538L55.0592 110.803C54.6918 110.86 54.3244 110.888 53.957 110.888C51.4134 110.888 48.785 109.814 46.7219 107.949L44.3479 105.802C44.2631 105.887 44.1783 105.943 44.0935 106C42.2 107.893 42.5674 111.227 44.9414 113.375L49.6329 117.614H49.6612Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35 105.066C50.7349 106.338 52.4589 106.988 53.9568 106.988C55.4547 106.988 55.9634 106.649 56.6417 105.971C58.2809 104.332 57.8569 101.026 55.709 98.6519L54.1546 96.9281C53.9568 96.9281 53.7589 96.9281 53.5611 96.9281C51.0175 96.9281 48.4174 95.8826 46.4108 94.0458L44.0933 91.9265C43.8107 92.096 43.5281 92.2939 43.2737 92.5482C41.2671 94.5545 41.578 97.9454 43.952 100.093L49.3218 104.982L49.35 105.066Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0404 91.2201C50.3969 92.4634 52.0644 93.0851 53.5906 93.0851C55.1167 93.0851 55.7667 92.7178 56.5015 91.9831C58.2255 90.2593 57.8864 86.8966 55.7385 84.523L50.1991 78.391C49.0404 77.1194 47.4859 76.4695 45.9881 76.4695C44.4902 76.4695 43.4162 76.9499 42.4553 77.9106C40.3356 80.03 40.5617 83.5057 42.9358 85.6533L49.0686 91.1918L49.0404 91.2201Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 76.673L56.8407 80.817V43.0308H95.1305V59.2111C96.3619 57.8679 97.7985 56.9533 98.9712 56.3532V41.8876C98.9712 38.1151 95.8048 35 91.9055 35H60.0657C56.1957 35 53 38.0866 53 41.8876V76.673Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1294 78.3308V111.883H60.4164C60.1526 113.312 59.5076 120.342 58.4228 121.4C58.0417 121.771 57.6019 122.086 57.1621 122.371C58.0417 122.771 59.0092 123 60.0646 123H91.9337C95.8037 123 98.9994 119.914 98.9994 116.113V87.8477C97.8267 85.1612 96.3021 81.5031 95.1587 78.3308H95.1294Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7202_104951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydata);
export default __webpack_public_path__ + "static/media/mydata.7281d91ed266eb6ca7bc7f2f44036667.svg";
export { ForwardRef as ReactComponent };